const general = {
  specialOffers: 'Special\nOffers',
  restaurantLabel: 'Breakfast',
  readMore: 'Read More',
  rooms: 'Rooms',
  contactForm: {
    placeholder: 'Email Address',
    sendAction: 'Send',
    sentLabel: 'Thanks',
    explanation: 'Receive our news and new offers !',
  },
  info: {
    tel: '+382 67 051 736',
    address: 'Cara Dušana 2 85310 Budva Montenegro',
    mail: 'office@lavillabudva.com',
  },
  booking: {
    arrival: 'Arrival Date',
    nights: 'Nights',
    check: 'Book',
    cancel: 'Change/Cancel Reservation',
    code: 'Access code',
    optional: 'Optional',
  },
};

export default general;